document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
              // setTimeout(() => {
              //   debugger;
              //   if(document.querySelector('.cart-upsell') && !document.querySelector('.cart-upsell .flickity-viewport')){
              //     var elem = document.querySelector('.cart-upsell ul');
              //     console.log(elem, 'elem');
              //     var flkty = new Flickity( elem, {
              //       prevNextButtons: false
              //     });
              //   }
              // }, 500);
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
